import { Typography } from '@/components/Typography';
import type { WithChildren } from '@/lib/types';

import * as S from './styles';

export const ServerSuccesses = ({ children }: WithChildren) => {
  return (
    <S.ServerSuccessesWrapper data-test-id='ServerSuccessesWrapper' my={2}>
      <Typography data-test-id='ServerSuccessesTypography' scale='p3'>
        {' '}
        {/* NOSONAR */}
        {children}
      </Typography>
    </S.ServerSuccessesWrapper>
  );
};
